module.exports = __webpack_public_path__ + "img/LUB00184.609a44a7.png";